import { logoutRequest } from './redux/actions/account_actions/login.actions';

let timeoutID; let
    newProps;

export const checkUserActivity = (props) => {
    newProps = props;
    window.addEventListener('mousemove', resetTimer, false);
    window.addEventListener('mousedown', resetTimer, false);
    window.addEventListener('keypress', resetTimer, false);
    window.addEventListener('DOMMouseScroll', resetTimer, false);
    window.addEventListener('mousewheel', resetTimer, false);
    startTimer();
};

function startTimer() {
    timeoutID = window.setTimeout(goInactive, 3000000);
}

function resetTimer() {
    window.clearTimeout(timeoutID);
    startTimer();
}

function goInactive() {
    newProps.dispatch(logoutRequest('lockedScreen'));
}



// WEBPACK FOOTER //
// ./src/modules/App/CheckUserActivity.js